import TopBar from "../component/TopBar";
import MenuBar from "../component/MenuBar";
import Footer from "../component/Footer";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container } from "react-bootstrap";

const PurchaseRegistrationListing = () => {
  return (
    <>
      <BreadCrumbSecttion
        pageTitle="Notification"
        currentPageName="Notification"
      />
      <section className="padTop50">
       <container>
  <button type="button" className="btn btn-primary">open slider</button>
  <div className="offcanvas-body">
    <p>ndsfjksdkjfhsdfhsjkf</p>
    <button>dsfsdf</button>
  </div>
</container>

      </section>
     
    </>
  );
};

export default PurchaseRegistrationListing;
